import permission from './permission'
import fitColumns from './fitColumns'

export default (app) => {
    app.directive('permission', permission)
    app.directive('fitColumns', fitColumns)
}
